<template>
  <div id="app">
    <loader-overlay v-if="isLoading()" />
    <router-view v-if="shouldShowSinglePage" :key="$route.fullPath" />
    <landing-page v-else-if="shouldShowLandingPage" />
    <router-view v-else-if="shouldShowGuestPage" :key="$route.fullPath" />
    <onboard v-else-if="!isMobile && shouldOnboard" />
    <mobile-onboard v-else-if="isMobile && shouldOnboard" />
    <div
      v-else-if="isMobile"
      class="mobile-root"
      :class="{ withBottom: shouldShowBottomMenu }"
    >
      <main id="main">
        <router-view :key="$route.fullPath" id="app-container" />
      </main>
      <bottom-tab-menu v-if="!isLoading() && shouldShowBottomMenu" />
      <mobile-overlay />
    </div>
    <div v-else-if="!isMobile" class="grid-container">
      <topbar />
      <sidebar v-if="shouldShowSidebar" />
      <main id="main">
        <router-view :key="$route.fullPath" id="app-container" />
      </main>
    </div>
    <signup-please-modal />
    <auth-modal />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import LandingPage from "@/views/LandingPage.vue";
import Onboard from "./views/Onboard.vue";
import MobileOnboard from "./views/MobileOnboard.vue";
import Topbar from "@/components/Topbar.vue";
import Sidebar from "@/components/Sidebar.vue";
import BottomTabMenu from "./components/BottomTabMenu.vue";
import MobileOverlay from "./components/MobileOverlay.vue";
import SignupPleaseModal from "./components/SignupPleaseModal.vue";
import AuthModal from "./components/AuthModal.vue";
import LoaderOverlay from "./components/LoaderOverlay.vue";

export default {
  components: {
    LandingPage,
    Onboard,
    Topbar,
    Sidebar,
    BottomTabMenu,
    MobileOverlay,
    SignupPleaseModal,
    AuthModal,
    MobileOnboard,
    LoaderOverlay,
  },
  data() {
    return {
      route: "LandingPage",
    };
  },
  computed: {
    ...mapGetters({
      isLoggedIn: "auth/isLoggedIn",
      isOnboarded: "auth/isOnboarded",
      getNotifications: "notification/getNotifications",
    }),
    isMobile() {
      return screen.width < 768;
    },
    shouldShowSinglePage() {
      const singlePages = ["Lineup", "About"];
      return singlePages.includes(this.route);
    },
    shouldShowGuestPage() {
      const guestPages = ["Login", "Signup"];
      return !this.isLoggedIn && guestPages.includes(this.route);
    },
    shouldShowSidebar() {
      const pagesWithNoSidebar = ["Lineup"];
      return !pagesWithNoSidebar.includes(this.route);
    },
    shouldShowBottomMenu() {
      const pagesWithNoBottomMenu = [
        "Login",
        "Signup",
        "LandingPage",
        "List",
        "Lineup",
      ];
      return this.isMobile && !pagesWithNoBottomMenu.includes(this.route);
    },
    shouldOnboard() {
      const guestPages = ["Lineup"];
      return (
        this.isLoggedIn && !this.isOnboarded && !guestPages.includes(this.route)
      );
    },
    shouldShowLandingPage() {
      return !this.isLoggedIn && this.route == "LandingPage";
    },
  },
  created() {
    this.$store.dispatch("loading/resetLoading");
    this.loadUserInfo();
    this.route = this.$router.currentRoute.name;
  },
  mounted() {
    // First we get the viewport height and we multiple it by 1% to get a value for a vh unit
    let vh = window.innerHeight * 0.01;
    // Then we set the value in the --vh custom property to the root of the document
    document.documentElement.style.setProperty("--vh", `${vh}px`);

    if (this.isOnboarded) {
      var redirectPath = sessionStorage.getItem("redirectPath") || "/";
      if (redirectPath !== "/") {
        this.$router.push(redirectPath);
      }
      sessionStorage.setItem("redirectPath", "/");
    }
  },
  watch: {
    isLoggedIn(value, oldValue) {
      if (value) {
        this.loadUserInfo();
      }
      if (oldValue == false && value == true) {
        this.$store.dispatch("auth/justLoggedIn");
      }
    },
    $route(to, from) {
      this.route = to.name;
    },
  },
  methods: {
    loadUserInfo() {
      this.$store
        .dispatch("auth/loadMe")
        .then((user) => {
          Promise.all([
            this.$store.dispatch("notification/checkForUnreadNotifications"),
            this.$store.dispatch("notification/fetchNotifications", 0),
            this.$store.dispatch("product/resetFeed"),
          ]).then(
            (response) => {},
            (error) => {}
          );
        })
        .catch(() => {});
    },
  },
};
</script>

<style lang="scss">
* {
  box-sizing: border-box;
  user-select: none;
  outline: 0;
  padding: 0;
  margin: 0;
}
html {
  font-size: 56.25%;
}
body {
  overflow-anchor: none;
  font-size: 1.4rem;
  font-weight: 300;
  line-height: 1.6;
  font-family: "Roboto", sans-serif;
  color: black;
  min-height: 100%;
}
a {
  text-decoration: none;
  color: inherit;
  -webkit-tap-highlight-color: transparent;
  cursor: pointer;
}
input {
  -webkit-user-select: text;
}
ul {
  padding-left: 0;
}
button {
  border: none;
  background-color: inherit;
  font: inherit;
  color: inherit;
  -webkit-tap-highlight-color: transparent;
}
#app {
  display: flex;
  flex-direction: column;
  min-height: 100%;
  height: 100%;
  height: calc(var(--vh, 1vh) * 100);
}
// #app {
// width: 100%;
// display: flex;
// flex-direction: column;
// height: 100%;
// flex: 1;
// color: #fff;
// }
main {
  min-width: 0;
  grid-area: main-view;
  background: white;

  width: 100%;
  position: relative;
  // display: flex;
  // flex-direction: column;
  min-height: 0;
  overflow-x: hidden;
  overflow-y: auto;
  // flex: 1;
}
.grid-container {
  min-height: 100%;
  width: 100%;
  flex: 1;
  position: relative;
  display: grid;
  grid-template-rows: 1fr auto;
  grid-template-columns: auto 1fr;
  grid-template-areas: "nav-bar main-view";
  // main {
  //   background: white;
  //   grid-area: main-view;
  //   width: 100%;
  //   position: relative;
  //   display: flex;
  //   flex-direction: column;
  //   min-height: 0;
  //   overflow-x: hidden;
  //   overflow-y: auto;
  //   flex: 1;
  //   // height: 100%;
  //   &::-webkit-scrollbar {
  //     width: 10px;
  //   }
  //   &::-webkit-scrollbar-track {
  //     background-color: transparent;
  //   }
  //   &::-webkit-scrollbar-thumb {
  //     border-radius: 5px;
  //     background-color: #515769;
  //   }
  //   &::-webkit-scrollbar-thumb:hover {
  //     border-radius: 5px;
  //     background-color: #767880;
  //   }
  // }
}
#app-container {
  flex: 1;
}

.mobile-root {
  flex: 1;
  display: flex;
  //   display: block;
  //   height: 100%;
  //   overflow: hidden scroll;
  //   padding-bottom: 0;
  //   position: relative;
  //   text-align: center;
  //   width: 100%;
  //   transition: filter 0.2s ease 0s;
  &.withBottom {
    padding-bottom: 52px;
  }
  //   main {
  //     height: 100%;
  //     overflow: hidden;
  //     width: 100%;
  //     #app-container {
  //       height: 100%;
  //       width: 100%;
  //       overflow: hidden auto;
  //       position: relative;
  //       z-index: 1;
  //       // display: flex;
  //       @media (max-width: 768px) {
  //         // background: black;
  //       }
  //     }
  //   }
}
.vm--container {
  background: #000000bb;
  overflow: auto;
}
.vm--modal {
  background-color: #fff;
  box-shadow: 1rem 1rem 4rem rgb(0 0 0 / 50%);
  border-radius: 0.5rem;
}
.product-modal {
  .vm--modal {
    margin-left: 0;
    @media (min-width: 1200px) {
      margin-left: calc(#{$nav_width} / 2) !important;
    }
  }
}

.slider {
  height: 60vh !important;
}
.slider-indicators-center {
  left: 0 !important;
  transform: inherit !important;
  display: flex;
  justify-content: center;
  width: 100%;
  margin-bottom: 8px;
}
.slider-indicators {
  flex-direction: row;
  color: #212529;
  /*background-color: rgba(255,255,255,0.8);*/
  background-color: transparent;
  /*background-color: white;*/
  /*box-shadow: 0px 0px 2px 1px rgba(255, 255, 255, 0.7);*/
  bottom: 1px !important;
  // padding: 10px 20px;
  border-radius: 6px;
}
.slider-icon {
  padding: 7px;
  border-left: 2px solid #212529 !important;
  border-bottom: 2px solid #212529 !important;
  // border-left: 3px solid $primary1 !important;
  // border-bottom: 3px solid $primary1 !important;
}
.slider-btn {
  // display: none;
}
.slider-btn-right {
  background: linear-gradient(
    -90deg,
    rgba(0, 0, 0, 0.2),
    rgba(0, 0, 0, 0)
  ) !important;
  z-index: 500 !important;
  &:hover {
    background: linear-gradient(
      -90deg,
      rgba(0, 0, 30, 0.3),
      rgba(0, 0, 0, 0)
    ) !important;
  }
}
.slider-btn-left {
  background: linear-gradient(
    90deg,
    rgba(0, 0, 0, 0.2),
    rgba(0, 0, 0, 0)
  ) !important;
  z-index: 500 !important;
  &:hover {
    background: linear-gradient(
      90deg,
      rgba(0, 0, 30, 0.3),
      rgba(0, 0, 0, 0)
    ) !important;
  }
}
.slider-indicator-icon {
  background-color: #212529 !important;
}
.slider-indicator-active {
  // background-color: #3082c9 !important;
  background-color: $primary1 !important;
}
#easy-toast-default {
  bottom: 20px;
  background-color: rgba(48, 45, 55, 0.8);
  border-radius: 10px;
  min-width: 230px;
}
</style>
